// extracted by mini-css-extract-plugin
export default {"benefits":"styles_benefits__rs3Ne","title":"styles_title__W4zQ2","list":"styles_list__mv2qG","listItem":"styles_listItem__DGGE7","icon":"styles_icon__7iITr"};